// D-889: 「不具合・要望」ボタンに出す 対応済み(返信あり)で まだ見ていない 件数。
//   取り方は件数だけ(countUnseenReplies = head:true)。ポーリングはしない。
//   取り直すのは ①マウント時 ②アプリが前面に戻ったとき(focus / visibilitychange=visible)
//   ③呼び出し側が refresh() を呼んだとき(シートを開いた・閉じた・既読にした)。
//   ★focus と visibilitychange は同時に来ることがあるので、取得中は重ねて投げない。
import { useCallback, useEffect, useRef, useState } from 'react'
import { countUnseenReplies } from '../services/appFeedback'

export function useFeedbackReplyBadge(staffId) {
  const [count, setCount] = useState(0)
  const inflight = useRef(false)
  const alive = useRef(true)

  const refresh = useCallback(async () => {
    if (!staffId || inflight.current) return
    inflight.current = true
    try {
      const n = await countUnseenReplies(staffId)
      // 引けなかった(null)ときは 0 = バッジを出さない(誤った数を出さない)。
      if (alive.current) setCount(typeof n === 'number' && n > 0 ? n : 0)
    } catch {
      if (alive.current) setCount(0)
    } finally {
      inflight.current = false
    }
  }, [staffId])

  useEffect(() => {
    alive.current = true
    refresh()
    const onFocus = () => { refresh() }
    const onVisible = () => {
      try { if (document.visibilityState === 'visible') refresh() } catch { /* ignore */ }
    }
    window.addEventListener('focus', onFocus)
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      alive.current = false
      window.removeEventListener('focus', onFocus)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [refresh])

  return { count, refresh }
}
